/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LicenseAgreementRestService, LicenseAgreementType } from '@gh/builder-shared-data';
import {
  DictionaryService,
  getRouteParam,
  InitViewService,
  isRouteForCreationMode,
} from '@gh/common-shared';
import { loadTinymce } from '@gh/core-ui';
import { Observable } from 'rxjs';
import { LicenseAgreementDetails, newLicenseAgreementDetails } from './license-agreements.model';

@Injectable()
export class LicenseAgreementDetailsBusinessService implements InitViewService {
  constructor(private licenseAgreementRest: LicenseAgreementRestService,
              private dictionaries: DictionaryService) {
  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      licenseAgreementTypeDict: this.dictionaries.getByEnum(LicenseAgreementType),
      details: isRouteForCreationMode(route)
        ? newLicenseAgreementDetails()
        : this.licenseAgreementRest.get(getRouteParam(route, 'licenseAgreementId')),
      tinymce: loadTinymce(),
    };
  }

  save(template: LicenseAgreementDetails): Observable<LicenseAgreementDetails> {
    if (template.id) {
      return this.licenseAgreementRest.update(template);
    } else {
      return this.licenseAgreementRest.create(template);
    }
  }
}
